import './Candidate.css'
import TableHead from "../../../components/utilities/table/TableHead";
import TableRow from "../../../components/utilities/table/TableRow";
import {IFRAME_DOMAIN} from "../../../utilities/Constants";
import {useContext,useMemo, useEffect,useCallback, useState} from "react";
import Status from "../../../components/quiz-result/Status";
import Table from "../../../components/utilities/table/Table";
import TransparentPageLayout from "../../../layout/page-layout/TransparentPageLayout";
import { ReactComponent as DeleteTestIcon } from '../../../assets/candidate-profile/DeleteIconBig.svg';
import FlexBox from "../../../components/utilities/FlexBox";
import {Button} from "react-bootstrap";
import TableBody from "../../../components/utilities/table/TableBody";
import ProfileImage from "../../../components/profile/ProfileImage";
import {Link, useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {resendTest} from '../candidate-utils/CandidateUtils'
import {resendResults} from '../candidate-utils/CandidateUtils'

import {
    getCandidateFullName
} from "../../../utilities/Utilities";
import {
    API_URL_PREFIX,
    APP_URL_PREFIX, PASS_THRESHOLD, TEST_REVIEW_PRIVILEGE,
} from "../../../utilities/Constants";
import Loader from "../../../components/utilities/Loader";
import {CameraFill, Images, Pencil, X} from "react-bootstrap-icons";
import ConfirmModal from "../../../components/utilities/ConfirmModal";
import RoundedLabel from "../../../components/utilities/RoundedLabel";
import {
    CustomErrorToast,
    CustomLoadingToast, CustomToastContainer, updateCustomErrorToast,
    updateCustomSuccessToast
} from "../../../components/utilities/CustomToast";
import SendTest from "../../../components/send-test/SendTest";
import CompanyTeamContext from "../../../CompanyTeamContext";
import Tooltip from "../../../components/utilities/Tooltip";
import {IframeModal, TestChartsButton, TestReviewButton, RestoreButton} from "../../quiz/quiz/QuizzesList";
import {getTestName, isLiveTestOrQuiz} from "../../test/tests-list/TestsList";
import PencilIcon from '../../../assets/candidate-profile/PencilIcon.svg';
import DeleteIcon from '../../../assets/candidate-profile/DeleteIcon.svg';
import HoverPencilIcon from '../../../assets/candidate-profile/HoverPencilIcon.svg';
import HoverDeleteIcon from '../../../assets/candidate-profile/HoverDeleteIcon.svg';
import DisqualifiedIcon from '../../../assets/candidate-profile/DisqualifiedIcon.svg';
import candidateEmail from '../../../assets/candidate-profile/candidateEmail.svg';
import candidatePhone from '../../../assets/candidate-profile/candidatePhone.svg';
import editCandidateMobile from '../../../assets/candidate-profile/editCandidateMobile.svg';
import deleteCandidateMobile from '../../../assets/candidate-profile/deleteCandidateMobile.svg';
import EditButton from "./edit-button/EditButton";
import DeleteButton from "./delete-button/DeleteButton";
import SendTestInvitation from './send-test-invitation-button/SendTestInvitation';
import DeleteTestButton from "./delete-test-button/DeleteTestButton";
import { ReactComponent as ScreenshotsIcon } from '../../../assets/candidate-profile/ScreenshotsIcon.svg';
import { ReactComponent as ProfilePicturesIcon1 } from '../../../assets/candidate-profile/ProfilePicturesIcon1.svg';
import testReportIcon from '../../../assets/candidate-profile/testReport.svg';
import { ReactComponent as ProfilePicturesIcon } from '../../../assets/candidate-profile/ProfilePicturesIcon.svg';
import { ReactComponent as ResendResultsIcon } from '../../../assets/candidate-profile/ResendResultsIcon.svg';
import ReactTooltip from 'react-tooltip';
import GradeMobileIcon from '../../../assets/dashboard/gradeMobile.svg';
import DateMobileIcon from '../../../assets/dashboard/dataMobile.svg';
import restoreTestIcon from '../../../assets/candidate-profile/restoreTest.svg';
import testResultsIcon from '../../../assets/candidate-profile/testResults.svg';
import testChartsIcon from '../../../assets/candidate-profile/testCharts.svg';
import resendTestIcon from '../../../assets/candidate-profile/resendTest.svg';
import deleteTestIcon from '../../../assets/candidate-profile/deleteTest.svg';
import viewProfilePicturesIcon from '../../../assets/candidate-profile/viewProfilePictures.svg';
import viewScreenshotsIcon from '../../../assets/tests-list/viewScreenShots.svg';
import notesIcon from '../../../assets/candidate-profile/notesIcon.svg';
import downArrowNotes from '../../../assets/candidate-profile/DownArrowNotes.svg';


const Candidate = ({refreshCandidates}) => {
    const [candidate, setCandidate] = useState({})
    const [loader, setLoader] = useState(true)

    const [quizzes, setQuizzes] = useState([])
    const {id} = useParams()
    const company = useContext(CompanyTeamContext)
    const navigate = useNavigate()

    // Add class to body when on candidate detail page for navbar styling
    useEffect(() => {
        document.body.classList.add('candidate-detail-page')
        return () => {
            document.body.classList.remove('candidate-detail-page')
        }
    }, [])

    useEffect(() => {
        axios.get( API_URL_PREFIX+"/GetCandidate.html?id=" + id)
            .then(res => res.data)
            .then(data => {
                if (data) {
                    setCandidate(data)
                    if(company){
                        document.title  = data.firstName + " - " + company.basicTitle
                    }
                }
            })
            .catch(e => setLoader(false) && console.log(e))
        return () => {
            if(company){
                document.title = company.basicTitle
            }
        }
    }, [id, company])

    const refresh = useCallback(() => {
        if(candidate && candidate.key){
            axios.get(API_URL_PREFIX+"/GetCandidateQuizzes.html?id="+candidate.key)
                .then(e=>{
                    setLoader(false)
                    let data = e.data;
                    if(!data || data.err){
                        CustomErrorToast("Error fetching quizzes: "+data.err.info)
                    }
                    else{
                        setQuizzes(data.sort((a,b)=> {
                            return b.date - a.date;
                        }))
                    }
                })
                .catch(err=>{
                    setLoader(false)
                    console.log(err)
                })
        }
    },[candidate])

    useEffect(() => {
        refresh(); // Call refresh when candidate changes
    }, [refresh]);


    if(loader){
        return (<TransparentPageLayout>
            <Loader loader={loader}/>
        </TransparentPageLayout>)
    }

    return (<TransparentPageLayout>
        <Loader loader={loader}/>
        <CustomToastContainer />
        <Header candidate={candidate} quizzes={quizzes} refreshCandidates={refreshCandidates}/>
        <MobileCandidateCard candidate={candidate} refreshCandidates={refreshCandidates}/>
        <FlexBox className="quizzes-container" justify={"top"} direction={"column"} style={{width: "100%", marginTop: "28px"}}>
            <Quizzes  setQuizzes={setQuizzes} candidate={candidate} quizzes={quizzes} refresh={refresh}/>
        </FlexBox>
        <br/>
        <FlexBox className="desktop-notes" justify={"top"} direction={"column"} style={{width: "100%"}}>
            <Notes candidate={candidate}/>
        </FlexBox>
    </TransparentPageLayout>)
}

const Header = ({candidate, quizzes, refreshCandidates}) => {
    const [showDelete, setShowDelete] = useState(false)
    const navigate = useNavigate();

    const deleteCandidate = () => {
        const id = CustomLoadingToast("Deleting...")
        axios.delete(API_URL_PREFIX+"/DeleteCandidate.html?id="+candidate.key)
        .then(e => {
            let data = e.data;
            if(data && !data.err){
                updateCustomSuccessToast("Deleted", id)
                refreshCandidates(); // Refresh the candidates list after deletion
                // Redirect back to candidates list after successful deletion
                navigate(APP_URL_PREFIX+"/candidate/list")
            }
            else{
                updateCustomErrorToast(data.info, id)
            }
            setShowDelete(false)
        })
        .catch(err => {
            setShowDelete(false)
            updateCustomErrorToast("Error, Please try again", id)
            console.log(err)
        })
    }
    return (<div>
        <ConfirmModal title={"Are you sure you want to delete " + getCandidateFullName(candidate) + "?"}
                      body={"this operation is permanent and can not be undone"}
                      callback={deleteCandidate}
                      yes={"Delete"}
                      no={"Cancel"}
                      variant={"danger"}
                      setShow={setShowDelete}
                      show={showDelete}
        />
        <FlexBox className={"container candidate-desktop-header"} justify={"space-between"} style={{padding: "0px 0px", width: "80vw"}}>
            <FlexBox justify={"start"} style={{width: "70%"}}>
                <div>
                    <Link style={{
                        marginBottom: "8px",
                        color: "#4C1AFF",
                        fontWeight: "700",
                        fontSize: "20px",
                        textDecoration: "none"
                    }} to={APP_URL_PREFIX+"/candidate/list"}>Candidates List</Link>
                </div>
                <div style={{
                    color: "#979DA5", fontWeight: "700", fontSize: "20px"
                }}>&nbsp;/&nbsp;{getCandidateFullName(candidate)}</div>
            </FlexBox>
            <FlexBox style={{width: "30%"}} justify={"end"}>
                <EditButton onClick={() => (navigate(APP_URL_PREFIX+"/candidate/" + candidate.key + "/edit"))} label="Edit" icon={PencilIcon} hoverIcon={HoverPencilIcon}/>&nbsp;
                <DeleteButton onClick={() => setShowDelete(true)} label="Delete" icon={DeleteIcon} hoverIcon={HoverDeleteIcon}/>
            </FlexBox>
        </FlexBox>
        <FlexBox style={{marginTop: "28px", padding: "0px"}} className={"container candidate-desktop-header"} align={"center"} justify={"space-between"}>
            <CandidateDetails candidate={candidate}/>
            <QuizStats candidate={candidate} quizzes={quizzes}/>
            <CandidateStats candidate={candidate} quizzes={quizzes}/>
        </FlexBox>
    </div>)
}

const CandidateDetails = ({candidate}) => {
    return (<FlexBox justify={"center"} align={"center"} className={"candidate-details"}
                     style={{
                        width: "30%", height: "110px", padding: "30px",
                        background: 'linear-gradient(135deg, rgba(92, 84, 238, 1) 13%, rgba(106, 129, 253, 1) 100%)',
                        backgroundColor: 'rgba(255, 255, 255, 1.0)', border: 'none', borderRadius: '8px',
                        boxShadow: '-0.86px 4.28px 6.84px rgba(0, 0, 0, 0.2)' }}>
        <FlexBox justify={"space-between"} style={{width: "100%"}}>         
            <FlexBox align={"center"} direction={"column"} style={{width: "100%"}}>
                <div id={"fullName"} style={{
                    lineHeight: "20px", color: "#ffffff", fontWeight: 700, fontSize: "20px",
                    fontFamily: "Nunito, Helvetica, sans-serif", letterSpacing: "0", marginBottom: "12px"
                }}>{getCandidateFullName(candidate)}</div>
                <div style={{color: "#fff", fontWeight: 400, fontSize: "16px", letterSpacing: "0", fontFamily: '"Lexend-Regular", Helvetica'}}>{candidate.email}</div>
                <div style={{color: "#fff", fontWeight: 300, fontSize: "16px", letterSpacing: "0", fontFamily: '"Lexend-Regular", Helvetica'}}>{candidate.mobile}</div>
            </FlexBox>
        </FlexBox>
    </FlexBox>);
}

function QuizStats({candidate, quizzes}) {
    return (<FlexBox align={"center"} className={"candidate-details"}
                     style={{width: "30%", height: "110px", background: "#fff", padding: "30px",
                             border: "1px solid", borderColor: "transparent", borderRadius: "12px", boxShadow: '-1px 5px 8px rgba(0, 0, 0, 0.2)'}}>
        <FlexBox justify={"space-between"} style={{width: "100%"}}>
            <RoundedLabel value={quizzes.length} style={{ fontWeight: 700}} background='#EAE9FF' color='#6D50FF'/>

            <FlexBox align={"start"} direction={"column"} style={{width: "80%", }}>
                <div style={{
                    lineHeight: "20px", width: "80%",
                    color: "#000000", fontFamily: "Nunito, Helvetica, sans-serif", fontSize: "18px", fontWeight: "500", letterSpacing: "0", whiteSpace: "nowrap"
                }}>Tests assigned
                </div>
                <div style={{
                    color: "#000000", fontFamily: "Nunito, Helvetica, sans-serif",
                    fontSize: "14px", fontWeight: "500", paddingLeft: "3px", letterSpacing: "0", whiteSpace: "nowrap"
                    }}>to {candidate.firstName}</div>
            </FlexBox>

        </FlexBox>
    </FlexBox>);
}

function CandidateStats({candidate, quizzes}) {
    return (<FlexBox align={"center"} className={"candidate-details"}
                     style={{width: "30%", height: "110px", background: "#fff", padding: "30px",
                             border: "1px solid", borderColor: "transparent", borderRadius: "12px", boxShadow: '-1px 5px 8px rgba(0, 0, 0, 0.2)'}}>
        <FlexBox justify={"space-between"} style={{width: "100%"}}>
            <RoundedLabel value={quizzes.filter(e=>e.quizScore >= 0).length} style={{ fontWeight: 700}} background='#EAE9FF' color='#6D50FF' />

            <FlexBox align={"start"} direction={"column"} style={{width: "80%"}}>
                <div style={{
                    lineHeight: "20px", width: "80%",
                    color: "#000000", fontFamily: "Nunito, Helvetica, sans-serif", fontSize: "18px", fontWeight: "500", letterSpacing: "0", whiteSpace: "nowrap"
                }}>Tests Taken
                </div>
                <div style={{
                    color: "#000000", fontFamily: "Nunito, Helvetica, sans-serif",
                    fontSize: "14px", fontWeight: "500", paddingLeft: "3px", letterSpacing: "0", whiteSpace: "nowrap"
                    }}>by {candidate.firstName}</div>
            </FlexBox>

        </FlexBox>
    </FlexBox>);
}

const MobileCandidateCard = ({candidate, refreshCandidates}) => {
    const [showDelete, setShowDelete] = useState(false)
    const navigate = useNavigate();

    const deleteCandidate = () => {
        const id = CustomLoadingToast("Deleting...")
        axios.delete(API_URL_PREFIX+"/DeleteCandidate.html?id="+candidate.key)
        .then(e => {
            let data = e.data;
            if(data && !data.err){
                updateCustomSuccessToast("Deleted", id)
                refreshCandidates();
                navigate(APP_URL_PREFIX+"/candidate/list")
            }
            else{
                updateCustomErrorToast(data.info, id)
            }
            setShowDelete(false)
        })
        .catch(err => {
            setShowDelete(false)
            updateCustomErrorToast("Error, Please try again", id)
            console.log(err)
        })
    }

    return (
        <>
            <ConfirmModal title={"Are you sure you want to delete " + getCandidateFullName(candidate) + "?"}
                          body={"this operation is permanent and can not be undone"}
                          callback={deleteCandidate}
                          yes={"Delete"}
                          no={"Cancel"}
                          variant={"danger"}
                          setShow={setShowDelete}
                          show={showDelete}
            />
            <div className="mobile-candidate-card">
                <div className="mobile-candidate-card-content">
                    <div className="mobile-candidate-card-left">
                        <ProfileImage name={getCandidateFullName(candidate)} />
                    </div>
                    <div className="mobile-candidate-card-middle">
                        <div className="mobile-candidate-name">{getCandidateFullName(candidate)}</div>
                        {candidate.email && (
                            <div className="mobile-candidate-info-row">
                                <img src={candidateEmail} alt="Email" className="mobile-candidate-icon" />
                                <span className="mobile-candidate-text">{candidate.email}</span>
                            </div>
                        )}
                        {candidate.mobile && (
                            <div className="mobile-candidate-info-row">
                                <img src={candidatePhone} alt="Phone" className="mobile-candidate-icon" />
                                <span className="mobile-candidate-text">{candidate.mobile}</span>
                            </div>
                        )}
                    </div>
                    <div className="mobile-candidate-card-right">
                        <img src={editCandidateMobile} alt="Edit" className="mobile-candidate-action-icon" onClick={() => navigate(APP_URL_PREFIX+"/candidate/" + candidate.key + "/edit")} />
                        <img src={deleteCandidateMobile} alt="Delete" className="mobile-candidate-action-icon" onClick={() => setShowDelete(true)} />
                    </div>
                </div>
            </div>
        </>
    );
}

const MobileTestCard = ({quiz, candidate, refresh, setQuizzes, setIframeSrc, setShowIframe, isPending}) => {
    const [showMenu, setShowMenu] = useState(false)
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const navigate = useNavigate()
    const contextValue = useContext(CompanyTeamContext)
    const company = useMemo(() => contextValue || {}, [contextValue])
    const [privileges, setPrivileges] = useState([])
    const [touchStart, setTouchStart] = useState(0)
    const [translateY, setTranslateY] = useState(0)
    const [isScrollingContent, setIsScrollingContent] = useState(false)
    const [showHandleBar, setShowHandleBar] = useState(true)

    useEffect(() => {
        if(company && company.privileges){
            setPrivileges(company.privileges || [])
        }
    }, [company])

    // Drag-down functionality for bottom sheet
    useEffect(() => {
        if (!showMenu) return

        const bottomSheet = document.querySelector('.quiz-menu-bottom-sheet')
        const backdrop = document.querySelector('.quiz-menu-backdrop')
        if (!bottomSheet || !backdrop) return

        const handleScroll = (e) => {
            if (e.target.scrollTop > 0) {
                setShowHandleBar(false)
            } else {
                setShowHandleBar(true)
            }
        }

        let scrollableElement = null
        let initialScrollTop = 0

        const handleTouchStart = (e) => {
            const target = e.target
            const menuContent = target.closest('.quiz-menu-content')

            if (menuContent) {
                scrollableElement = menuContent
                initialScrollTop = menuContent.scrollTop
            } else {
                scrollableElement = null
            }

            setTouchStart(e.touches[0].clientY)
        }

        const handleTouchMove = (e) => {
            if (touchStart === 0) return

            const touchCurrent = e.touches[0].clientY
            const diff = touchCurrent - touchStart

            if (scrollableElement) {
                const currentScrollTop = scrollableElement.scrollTop

                if (currentScrollTop === 0 && diff > 0) {
                    e.preventDefault()
                    setTranslateY(diff)
                    setIsScrollingContent(false)
                } else {
                    setIsScrollingContent(true)
                    setTranslateY(0)
                }
            } else {
                if (diff > 0) {
                    e.preventDefault()
                    setTranslateY(diff)
                }
            }
        }

        const handleTouchEnd = () => {
            if (translateY > 100) {
                setShowMenu(false)
            } else {
                setTranslateY(0)
            }
            setTouchStart(0)
            setIsScrollingContent(false)
            scrollableElement = null
        }

        const preventBackdropRefresh = (e) => {
            e.preventDefault()
        }

        bottomSheet.addEventListener('touchstart', handleTouchStart, { passive: true })
        bottomSheet.addEventListener('touchmove', handleTouchMove, { passive: false })
        bottomSheet.addEventListener('touchend', handleTouchEnd, { passive: true })
        backdrop.addEventListener('touchmove', preventBackdropRefresh, { passive: false })

        return () => {
            bottomSheet.removeEventListener('touchstart', handleTouchStart)
            bottomSheet.removeEventListener('touchmove', handleTouchMove)
            bottomSheet.removeEventListener('touchend', handleTouchEnd)
            backdrop.removeEventListener('touchmove', preventBackdropRefresh)
        }
    }, [showMenu, touchStart, translateY])

    const deleteQuiz = () => {
        const id = CustomLoadingToast("Deleting...")
        axios.delete(API_URL_PREFIX+"/DeleteQuizOfCandidate.html?quizId=" + quiz.key)
            .then(e => {
                let data = e.data
                if (data && !data.err) {
                    setQuizzes(quizzes => quizzes.filter(q => q.key != quiz.key))
                    if(company.refresh) company.refresh()
                    updateCustomSuccessToast("Deleted", id)
                } else {
                    updateCustomErrorToast(data.info, id)
                }
                setShowConfirmDelete(false)
                setShowMenu(false)
            })
            .catch(err => {
                setShowConfirmDelete(false)
                setShowMenu(false)
                updateCustomErrorToast("Error, Please try again", id)
                console.log(err)
            })
    }

    let scoreColor = "#28A745" // Green by default
    let scoreStatus = null
    let scoreStatusTooltip = null

    const disqualifyReasons = {
        1: "Disqualified: Failure to stay on the test tab.",
        2: "Disqualified: Print screen action detected during the test.",
        3: "Disqualified: Screen sharing was stopped during the test.",
        4: "Disqualified: Unauthorized use of AI tools detected.",
        5: "Disqualified: Unauthorized use of AI tools detected.",
        6: "Disqualified: Unauthorized use of Developer tools detected."
    }

    if (quiz.quizScore === -1) {
        scoreColor = "#6c757d" // Gray for no score
        if (quiz.disqualificationStatus >= 1 && quiz.disqualificationStatus <= 6) {
            scoreStatus = "DSQ"
            scoreStatusTooltip = disqualifyReasons[quiz.disqualificationStatus]
            scoreColor = "#FF3B30" // Red for disqualified
        } else {
            scoreStatus = "STOPPED"
            scoreColor = "#FF9500" // Orange for stopped
        }
    } else if (quiz.quizScore >= 0) {
        // Has a valid score
        if (quiz.disqualificationStatus >= 1 && quiz.disqualificationStatus <= 6) {
            // Restored but still disqualified
            scoreStatus = "DSQ"
            scoreStatusTooltip = disqualifyReasons[quiz.disqualificationStatus]
            scoreColor = "#FF3B30"
        } else if (quiz.disqualificationStatus > 6) {
            // Restored but stopped
            scoreStatus = "STOPPED"
            scoreColor = "#FF9500"
        } else {
            // Normal score
            if (quiz.quizScore < PASS_THRESHOLD) {
                scoreColor = "#DC3545" // Red for failed
            }
        }
    } else {
        // No score (pending)
        scoreColor = "#6c757d" // Gray
    }


    return (
        <>
            {showConfirmDelete && <ConfirmModal variant={"danger"} show={showConfirmDelete} setShow={setShowConfirmDelete}
                             callback={deleteQuiz} body={"Are you sure you want to delete " + getCandidateFullName(candidate)+ "'s "+quiz.name+" quiz?"}
                             title={"Confirm Delete"} yes={"Delete"} no={"Cancel"}
                             fallback={e => setShowConfirmDelete(false)}/>}

            {showMenu && (
                <>
                    <div className="quiz-menu-backdrop" onClick={() => setShowMenu(false)} />
                    <div className="quiz-menu-bottom-sheet" style={{
                        transform: `translateY(${translateY}px)`,
                        transition: translateY === 0 ? 'transform 0.3s ease' : 'none'
                    }}>
                        {showHandleBar && <div className="quiz-menu-handle-bar" />}
                        <button className="quiz-menu-close" onClick={() => setShowMenu(false)}>
                            <X size={24} />
                        </button>
                        <div className="quiz-menu-content">
                            {/* Supervised section */}
                            {(quiz.quizScore != null && (quiz.useWebCam || quiz.useSideProctoring) || quiz.supportPrintScreen || quiz.didRiskIdentified) && (
                                <div className="quiz-menu-section">
                                    <h4 className="quiz-menu-section-title">Supervised</h4>
                                    {quiz.quizScore != null && (quiz.useWebCam || quiz.useSideProctoring) && (
                                        <button className="quiz-menu-item" onClick={() => {
                                            setShowIframe(true)
                                            setIframeSrc(`https://www.questions-bank.com/ShowProfileImages.html?liteColor=1&quizId=${encodeURIComponent(quiz.key)}&candName=${encodeURIComponent(quiz.candidateName)}`)
                                            setShowMenu(false)
                                        }}>
                                            <img src={viewProfilePicturesIcon} alt="View Profile Pictures" />
                                            <span>View profile pictures</span>
                                        </button>
                                    )}
                                    {quiz.quizScore >= -1 && !(quiz.date && new Date(quiz.date) > new Date()) && (quiz.supportPrintScreen || quiz.didRiskIdentified) && (
                                        <button className="quiz-menu-item" onClick={() => {
                                            setShowIframe(true)
                                            setIframeSrc(`https://www.questions-bank.com/PrintScreenReport.htm?liteColor=1&testKey=${encodeURIComponent(quiz.key)}&testName=${encodeURIComponent(quiz.name)}&applicantName=${encodeURIComponent(quiz.candidateName)}`)
                                            setShowMenu(false)
                                        }}>
                                            <img src={viewScreenshotsIcon} alt="View Screenshots" />
                                            <span>View screenshots</span>
                                        </button>
                                    )}
                                </div>
                            )}

                            {/* Actions section */}
                            <div className="quiz-menu-section">
                                <h4 className="quiz-menu-section-title">Actions</h4>

                                {/* For PENDING tests (not completed) */}
                                {!(quiz.quizScore || quiz.quizScore === 0) && (
                                    <>
                                        <button className="quiz-menu-item" onClick={() => {
                                            resendTest(quiz.key, candidate.key).then(() => refresh())
                                            setShowMenu(false)
                                        }}>
                                            <img src={resendTestIcon} alt="Resend Test" />
                                            <span>Resend Test Invitation</span>
                                        </button>
                                        <div className="quiz-menu-divider" />
                                        <button className="quiz-menu-item" onClick={() => {
                                            setShowConfirmDelete(true)
                                            setShowMenu(false)
                                        }}>
                                            <img src={deleteTestIcon} alt="Delete" />
                                            <span>Delete test</span>
                                        </button>
                                    </>
                                )}

                                {/* For TAKEN tests (completed) */}
                                {(quiz.quizScore || quiz.quizScore === 0) && (
                                    <>
                                        {/* Test results - only if has TEST_REVIEW_PRIVILEGE and not -1 */}
                                        {privileges.includes(TEST_REVIEW_PRIVILEGE) && quiz.quizScore !== -1 && (
                                            <button className="quiz-menu-item" onClick={() => {
                                                navigate(APP_URL_PREFIX+"/quiz/review/" + quiz.key)
                                                setShowMenu(false)
                                            }}>
                                                <img src={testResultsIcon} alt="Test Review" />
                                                <span>Test review</span>
                                            </button>
                                        )}

                                        {/* Restore test - only if score is -1 (stopped/disqualified) and not live test */}
                                        {quiz.quizScore === -1 && !isLiveTestOrQuiz(quiz) && (
                                            <button className="quiz-menu-item" onClick={() => {
                                                const quizId = quiz.key
                                                axios.post(API_URL_PREFIX + "/RestoreQuizLiteByTK.html", null, {
                                                    headers: {
                                                        "Content-Type": "application/x-www-form-urlencoded"
                                                    },
                                                    params: {
                                                        companyId: company?.key || "MOCK_ID",
                                                        companyName: company?.name || "Mock Company",
                                                        testKey: quizId
                                                    }
                                                })
                                                .then(res => {
                                                    if (res.data?.result) {
                                                        updateCustomSuccessToast("Restoring test... please wait a few minutes, then refresh the page.")
                                                    } else {
                                                        CustomErrorToast(res.data?.info || "Restore failed.")
                                                    }
                                                })
                                                .catch(() => {
                                                    CustomErrorToast("Error restoring test. Please try again.")
                                                })
                                                setShowMenu(false)
                                            }}>
                                                <img src={restoreTestIcon} alt="Restore Test" />
                                                <span>Restore test</span>
                                            </button>
                                        )}

                                        {/* Test charts - only if not -1 (has valid score) and not live test */}
                                        {quiz.quizScore !== -1 && !isLiveTestOrQuiz(quiz) && (
                                            <button className="quiz-menu-item" onClick={() => {
                                                navigate(APP_URL_PREFIX+"/quiz/charts/" + quiz.key)
                                                setShowMenu(false)
                                            }}>
                                                <img src={testChartsIcon} alt="Test Results" />
                                                <span>Test results</span>
                                            </button>
                                        )}

                                        {/* Resend Results - only if completed and not -1 */}
                                        {quiz.quizScore !== -1 && (
                                            <button className="quiz-menu-item" onClick={() => {
                                                resendResults(quiz.key, candidate.key)
                                                setShowMenu(false)
                                            }}>
                                                <img src={resendTestIcon} alt="Resend Results" />
                                                <span>Resend Results</span>
                                            </button>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            )}

            <div className="quiz-mobile-card mobile-test-card">
                <div className="quiz-card-top mobile-test-card-top">
                    <div style={{display: "flex", flexDirection: "row", gap: "2vw", alignItems: "center", flex: 1}}>
                        <span className="mobile-test-card-top-label">Test Name</span>
                        <span className="mobile-test-card-top-value">{getTestName(quiz)}</span>
                    </div>
                    <button className="quiz-card-menu-button" onClick={() => setShowMenu(true)}>⋮</button>
                </div>
                <div className="mobile-test-card-divider" />
                <div className="mobile-test-card-bottom">
                    <div className="mobile-test-card-bottom-item" data-tip={scoreStatusTooltip || "Test score (0–100)"} data-for="dashboard-mobile-tooltip">
                        <img src={GradeMobileIcon} alt="Grade" />
                        <span className="mobile-test-card-bottom-value" style={{color: scoreColor}}>
                            {quiz.quizScore === -1
                                ? '--'
                                : (quiz.quizScore >= 0 ? `${Math.floor(quiz.quizScore)}%` : '--')}
                        </span>
                        {scoreStatus && (
                            <span
                                className="mobile-test-card-status-badge"
                                style={{
                                    marginLeft: '2vw',
                                    fontSize: '3vw',
                                    fontWeight: '600',
                                    color: scoreColor,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '1vw'
                                }}
                                data-tip={scoreStatusTooltip}
                                data-for="dashboard-mobile-tooltip"
                            >
                                {scoreStatus}
                                {scoreStatus === "DSQ" && <img src={DisqualifiedIcon} alt="DSQ" style={{width: '3vw', height: '3vw'}} />}
                            </span>
                        )}
                    </div>
                    <div className="mobile-test-card-bottom-item" style={{marginLeft: 'auto'}} data-tip="Last Modified" data-for="dashboard-mobile-tooltip">
                        <img src={DateMobileIcon} alt="Date" />
                        <span className="mobile-test-card-bottom-value">
                            {new Date(quiz.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                        </span>
                    </div>
                </div>
            </div>
        </>
    )
}

const Notes = ({candidate}) => {
    const [saving, setSaving] = useState(false)
    const [notes, setNotes] = useState("")

    useEffect(() => {
        if (candidate) setNotes(candidate.notes)
    }, [candidate])

    const saveNote = () => {
        setSaving(true)
        axios.put( API_URL_PREFIX+"/SaveNote.html", {key:candidate.key,notes: notes})
            .then(res => res.data)
            .then(data => {
                setSaving(false)
            })
            .catch(e => setSaving(false) && console.log(e))
    }

    return (<div className={"container"}
                 style={{background: "#fff", boxShadow: "0px 1px 16px 0px #30384B1A", height: "80%", padding: "20px", borderRadius: "12px"}}>
        <FlexBox justify={"center"} align={"start"} direction={"column"}>
            <FlexBox justify={"space-between"} style={{width: "100%"}}>
                <h3 style={{color: "#364454", fontWeight: "500", fontSize: "20px"}}>Notes</h3>
                {/* <Button onClick={saveNote} disabled={saving}
                        variant={"primary"}>{saving ? "Saving..." : "Save"}</Button> */}
            </FlexBox>
            <br/>
            <textarea value={notes} readOnly style={{cursor: "default"}} className={"input"} rows={4}/>
        </FlexBox>
        <br/>

    </div>)

}

const Quizzes = ({setQuizzes,candidate, quizzes, refresh}) => {
    const [sendTest, setSendTest] = useState(false)
    const [showIframe, setShowIframe] = useState(false)
    const [iframeSrc, setIframeSrc] = useState("")
    const [selectedTab, setSelectedTab] = useState('pending')

    const pendingQuizzes = quizzes.filter && quizzes.filter(e=>e.quizScore == null) || []
    const takenQuizzes = quizzes.filter && quizzes.filter(e=>e.quizScore != null) || []

    // Hide tooltips on scroll and touch for mobile
    useEffect(() => {
        const hideTooltip = () => {
            ReactTooltip.hide()
        }

        window.addEventListener('scroll', hideTooltip, true)
        window.addEventListener('touchstart', hideTooltip)
        window.addEventListener('touchmove', hideTooltip)

        return () => {
            window.removeEventListener('scroll', hideTooltip, true)
            window.removeEventListener('touchstart', hideTooltip)
            window.removeEventListener('touchmove', hideTooltip)
        }
    }, [])

    // Rebuild tooltips when quizzes change
    useEffect(() => {
        if (quizzes && quizzes.length > 0) {
            setTimeout(() => ReactTooltip.rebuild(), 100)
        }
    }, [quizzes])

    // Rebuild tooltips when selected tab changes
    useEffect(() => {
        setTimeout(() => ReactTooltip.rebuild(), 100)
    }, [selectedTab])

    return (<>
            {showIframe && <IframeModal setShow={setShowIframe} src={iframeSrc} />}
            {sendTest && <SendTest candidate={candidate} setShow={setSendTest} refresh={refresh} />}

            {/* Mobile Tabs */}
            <FlexBox className="mobile-tabs candidate-mobile-tabs" justify={"start"} style={{gap: "10px", marginBottom: "15px", display: "none"}}>
                <button
                    className={`tab-button ${selectedTab === 'pending' ? 'active' : ''}`}
                    onClick={() => setSelectedTab('pending')}
                >
                    Pending Tests
                </button>
                <button
                    className={`tab-button ${selectedTab === 'taken' ? 'active' : ''}`}
                    onClick={() => setSelectedTab('taken')}
                >
                    Tests Taken
                </button>
            </FlexBox>

            {/* Mobile Cards */}
            <div className="candidate-mobile-cards" style={{display: "none"}}>
                <div style={{marginBottom: "15px", display: "flex", justifyContent: "flex-end"}}>
                    <SendTestInvitation onClick={e => setSendTest(true)} />
                </div>
                {selectedTab === 'pending' && (
                    <>
                        {pendingQuizzes.length > 0 ? (
                            pendingQuizzes.map((quiz, i) => (
                                <MobileTestCard key={quiz.key} quiz={quiz} candidate={candidate} refresh={refresh} setQuizzes={setQuizzes} isPending={true} />
                            ))
                        ) : (
                            <div style={{textAlign: "center", color: "#bababa", padding: "20px"}}>No pending tests for {candidate.firstName}</div>
                        )}
                    </>
                )}
                {selectedTab === 'taken' && (
                    takenQuizzes.length > 0 ? (
                        takenQuizzes.map((quiz, i) => (
                            <MobileTestCard key={quiz.key} quiz={quiz} candidate={candidate} refresh={refresh} setQuizzes={setQuizzes} setIframeSrc={setIframeSrc} setShowIframe={setShowIframe} isPending={false} />
                        ))
                    ) : (
                        <div style={{textAlign: "center", color: "#bababa", padding: "20px"}}>No tests taken by {candidate.firstName}</div>
                    )
                )}
                <ReactTooltip id="dashboard-mobile-tooltip" className="dashboard-mobile-tooltip" type="dark" effect="solid" />
            </div>

            {/* Mobile Notes Card - Fixed at Bottom */}
            <MobileNotesCard candidate={candidate} />

            {/* Desktop Tables */}
            <div className={"container candidate-desktop-tables"}
                 style={{background: "#fff", boxShadow: "0px 1px 16px 0px #30384B1A", height: "80%", padding: "20px", borderRadius: "12px"}}>
            <FlexBox justify={"space-between"}>
            <h3 style={{color: "#364454", fontWeight: "500", fontSize: "20px"}}>Pending Tests for <span
                style={{fontWeight: "bold"}}>{candidate.firstName}</span></h3>
            <SendTestInvitation onClick={e => setSendTest(true)} />

        </FlexBox>
        <br/>
        <QuizzesTable setQuizzes={setQuizzes} quizzes={pendingQuizzes} candidate={candidate} label={"assigned to"} refresh={refresh} showScore={false} showSupervised={false} />

        {sendTest && <SendTest candidate={candidate} setShow={setSendTest} refresh={refresh} />}
    </div><br/>
            <div className={"container candidate-desktop-tables"}
                 style={{background: "#fff", boxShadow: "0px 1px 16px 0px #30384B1A", height: "80%", padding: "20px", borderRadius: "12px"}}>
                <FlexBox justify={"space-between"}>
                    <h3 style={{color: "#364454", fontWeight: "500", fontSize: "20px"}}>Tests Taken by <span
                        style={{fontWeight: "bold"}}>{candidate.firstName}</span></h3>
                </FlexBox>
                <br/>
                <QuizzesTable setIframeSrc={setIframeSrc} setShowIframe={setShowIframe} setQuizzes={setQuizzes} quizzes={takenQuizzes} candidate={candidate} label={"taken by"} refresh={refresh} showScore={true} showSupervised={true}/>

                {sendTest && <SendTest candidate={candidate} setShow={setSendTest} refresh={refresh} />}
            </div>
        </>
    )
}

const QuizzesTable = ({setQuizzes ,quizzes, candidate, label, setIframeSrc, setShowIframe,refresh, showScore, showSupervised }) => {
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [selectedQuiz, setSelectedQuiz] = useState()
    const contextValue = useContext(CompanyTeamContext);
    const company = useMemo(() => contextValue || {}, [contextValue]);


    let refreshQuota = company.refresh
    const [privileges, setPrivileges] = useState([])
    const navigate = useNavigate()

    useEffect(()=>{
        if(company && company.privileges){
            setPrivileges(company.privileges || []);
        }
    },[company])



    const deleteQuiz = () => {
        if(!selectedQuiz) return;
        const id = CustomLoadingToast("Deleting...")
        axios.delete(API_URL_PREFIX+"/DeleteQuizOfCandidate.html?quizId=" + selectedQuiz.key)
            .then(e => {
                let data = e.data;
                if (data && !data.err) {
                    setQuizzes(quizzes => quizzes.filter(e => e.key != selectedQuiz.key))
                    if(refreshQuota) refreshQuota();
                    updateCustomSuccessToast("Deleted", id)
                } else {
                    updateCustomErrorToast(data.info, id)
                }
                setShowConfirmDelete(false)
            })
            .catch(err => {
                setShowConfirmDelete(false)
                updateCustomErrorToast("Error, Please try again", id)
                console.log(err)
            })
    }

    if(!quizzes || !quizzes.length){
        return <div style={{maxHeight:"280px", overflow:"auto"}}>
            <Table>
            <TableHead columns={["", "", "", "", "","",""]}/>
            <TableBody>
                <tr>
                    <td></td>
                    <td style={{textAlign:"center", width:"100%", color:"#bababa"}}>No quizzes were {label} {candidate.firstName}</td>
                </tr>
            </TableBody>
        </Table>
        </div>;

    }

    const getColums = () => {
        const columns = [
        "", 
        "Test Name", 
        "Date"
        ];

        if (showScore) {
            columns.push(
                <FlexBox justify={"start"} style={{ height: "100%" }}>
                    Score&nbsp;<Tooltip text={"Score out of 100"} />
                </FlexBox>
            );
        }

        columns.push(
        <FlexBox justify={"start"} style={{ height: "100%" }}>
            Status&nbsp;<Tooltip text={"Pass score set at 60%"} />
        </FlexBox>
        );

        if (showSupervised) {
            columns.push(
                "Supervised"
            );
        }
        if (!showSupervised && !showScore) {
            columns.push(
                <div style={{ textAlign: "center", width: "100%" }}>
                    Action
                </div>
            );
            columns.push(" ");
        }
        else {
            columns.push(
                "Actions"
            );
        }
        console.log("COLUMNS:", columns);
        return columns;
    }

    return <div style={{maxHeight:"280px", overflow:"auto"}}><Table>

        <TableHead columns={getColums()}/>
        <TableBody>
            {quizzes && quizzes.length > 0 && quizzes.map((q, i) => {
                if(q.quizScore == null){
                    return (<TableRow>
                        <td style={{color:"#bababa"}}>{+i + 1}</td>
                        <td>{q.predefinedTest ? <span >{getTestName(q)}</span> : <Link className={"candidate-link"} to={APP_URL_PREFIX+"/test/"+q.quizTemplateKey}>{getTestName(q)}</Link>}</td>
                        <td>{new Date(q.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</td>

                        {showScore && <td></td>}
                        <td>
                        {q.isExpired ? (
                          <Status label={"EXPIRED"} status={"expired"}/>
                        ) : q.date && new Date(q.date) > new Date() ? (
                          <Status label={"SCHEDULED"} status={"scheduled"}/>
                        ) : (
                          <Status status={"pending"}/>
                        )}
                      </td>
                        <td style={{textAlign:"center"}}>
                            <ResendResultsIcon hidden={q.quizScore || q.quizScore === 0} onClick={() => {
                        	resendTest(q.key, candidate.key)
                        	      .then(() => {
                        	        refresh(); 
                        	      })
                        	      .catch((error) => {
                        	        console.error("Error during test resend:", error);
                        	      });
                            }} title='Resend Test' cursor="pointer" />
                        </td>
                        <td style={{textAlign:"center"}}>
                        	<DeleteTestIcon 
                        	style={{ cursor: "pointer" }}
                        	title='Delete Test' cursor="pointer"
                        	hidden={q.quizScore || q.quizScore === 0} 
                        	onClick={() => 
                        	{
                                    setSelectedQuiz(q);
                                    setShowConfirmDelete(true);
                                }}
                            />

                        </td>
                    </TableRow>)
                }
                else{
                    let score = q.quizScore;
                    let status=""
                    score = (score ? Math.floor(score): score)+"%";
                    if(q.quizScore == -1){
                        score = "--";
                        // TEST DISQUALIFIED - PRINT SCREEN
                        if("1"==(q.disqualificationStatus)){
                            status = 
                           (
                                <Tooltip text={"Disqualified: Failure to stay on the test tab."}>
                                    <span className="disqualified-frame">
                                    <span className="disqualified-text-wrapper">DSQ</span>
                                    <img
                                        className="disqualified-vector"
                                        alt="DisqualifiedIcon"
                                        src={DisqualifiedIcon}
                                    />
                                    </span>
                                </Tooltip>
                            );
                        }
                        // TEST DISQUALIFIED - NO GOOGLE
                        else if("2"==(q.disqualificationStatus)){
                            status = 
                           (
                                <Tooltip text={"Disqualified: Print screen action detected during the test."}>
                                    <span className="disqualified-frame">
                                    <span className="disqualified-text-wrapper">DSQ</span>
                                    <img
                                        className="disqualified-vector"
                                        alt="DisqualifiedIcon"
                                        src={DisqualifiedIcon}
                                    />
                                    </span>
                                </Tooltip>
                            );
                        }
                        // TEST DISQUALIFIED - Screen Share Cancel
                        else if("3"==(q.disqualificationStatus)){
                            status = 
                           (
                                <Tooltip text={"Disqualified: Screen sharing was stopped during the test."}>
                                    <span className="disqualified-frame">
                                    <span className="disqualified-text-wrapper">DSQ</span>
                                    <img
                                        className="disqualified-vector"
                                        alt="DisqualifiedIcon"
                                        src={DisqualifiedIcon}
                                    />
                                    </span>
                                </Tooltip>
                            );
                        }
                     // TEST DISQUALIFIED - ChatGPT
                        else if("4"==(q.disqualificationStatus) || "5"==(q.disqualificationStatus)){
                           status = 
                           (
                                <Tooltip text={"Disqualified: Unauthorized use of AI tools detected."}>
                                    <span className="disqualified-frame">
                                    <span className="disqualified-text-wrapper">DSQ</span>
                                    <img
                                        className="disqualified-vector"
                                        alt="DisqualifiedIcon"
                                        src={DisqualifiedIcon}
                                    />
                                    </span>
                                </Tooltip>
                            );
                        }
                        else if("6"==(q.disqualificationStatus)){
                                status = 
                                (
                                    <Tooltip text={"Disqualified: Unauthorized use of Developer tools detected."}>
                                        <span className="disqualified-frame">
                                        <span className="disqualified-text-wrapper">DSQ</span>
                                        <img
                                            className="disqualified-vector"
                                            alt="DisqualifiedIcon"
                                            src={DisqualifiedIcon}
                                        />
                                        </span>
                                    </Tooltip>
                                );
                        }
                        // TEST STOPPED IN THE MIDDLE
                        else{
                            status = (
                                <span className="stopped-button-frame">
                                    <span className="stopped-button-text-wrapper">STOPPED</span>
                                </span>
                            )
                        }
                    }
                    else{
                        status = <Status status={"pending"} />;
                        if (new Date(q.date).getTime() > Date.now()) {
                            status = <Status status={"scheduled"} label={"Scheduled"} />
                        }
                        if(q.quizScore || q.quizScore == 0){
                            if (q.quizScore >= 0 &&
                                q.disqualificationStatus >= 1 && q.disqualificationStatus <= 6) {
                                // Restored but still disqualified
                                const disqualifyReasons = {
                                    1: "Failure to stay on the test tab.",
                                    2: "Print screen action detected during the test.",
                                    3: "Screen sharing was stopped during the test.",
                                    4: "Unauthorized use of AI tools detected.",
                                    5: "Unauthorized use of AI tools detected.",
                                    6: "Unauthorized use of Developer tools detected.",
                                };
                                score = (
                                    <>
                                        {Math.floor(q.quizScore)}%{" "}
                                        <Tooltip text={"Disqualified: " + disqualifyReasons[q.disqualificationStatus]}>
                                        <img
                                            src={DisqualifiedIcon}
                                            alt="Disqualified"
                                            style={{ width: "16px", height: "16px", marginBottom: "4px", marginLeft: "4px" }}
                                        />
                                        </Tooltip>
                                    </>
                                );
                            }
                            else if (q.quizScore >= 0 && q.disqualificationStatus > 6) {
                                // Restored but disqualified with unknown code
                                score = (
                                    <>
                                        {Math.floor(q.quizScore)}%{" "}
                                        <span className="stopped-button-frame">
                                            <span className="stopped-button-text-wrapper">STOPPED</span>
                                        </span>
                                    </>
                                );

                            }
                            if((isLiveTestOrQuiz(q) && q.liveTestResult?.toLowerCase() !== 'passed' && q.liveTestResult?.toLowerCase() !== 'failed')) {
                                status = 'To be reviewed'
                            }
                            else if(q.quizScore > PASS_THRESHOLD || (isLiveTestOrQuiz(q) && q.liveTestResult?.toLowerCase() === 'passed')){
                                status = <Status status={"passed"} />
                            }
                            else{
                                status = <Status status={"failed"} />
                            }
                        }
                    }
                    return (<TableRow>
                        <td style={{color:"#bababa"}}>{+i + 1}</td>
                        <td>{q.predefinedTest ? <span >{getTestName(q)}</span> : <Link className={"candidate-link"} to={APP_URL_PREFIX+"/test/"+q.quizTemplateKey}>{getTestName(q)}</Link>}</td>
                        <td>{new Date(q.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</td>
                        <td>{isLiveTestOrQuiz(q) ? '--' : score}</td>
                        <td>{status}</td>
                        <td>
                            <FlexBox style={{gap: "12px"}} justify="start" align="center">
                                {(q.useWebCam || q.useSideProctoring) && <ProfilePicturesIcon style={{cursor:"pointer"}} onClick={e=>{
                                    setShowIframe(true)
                                    setIframeSrc(`https://www.questions-bank.com/ShowProfileImages.html?liteColor=1&quizId=${encodeURIComponent(q.key)}&candName=${encodeURIComponent((q.candidateName))}`)
                                }}
                                                                   title={"View Profile Pictures"} size={"25px"} color={"#125AB3"} />}
                         
                                {(q.didRiskIdentified || q.disqualificationStatus > 3) && <ScreenshotsIcon onClick={e=>{
                                    setShowIframe(true)
                                    setIframeSrc(`${IFRAME_DOMAIN}/PrintScreenReport.htm?liteColor=1&testKey=${encodeURIComponent(q.key)}&testName=${encodeURIComponent(q.name)}&applicantName=${encodeURIComponent(q.candidateName)}`)
                                }} style={{cursor:"pointer"}} size={"24px"} title={"View Screenshots"}  />}
                            </FlexBox>

                        </td>
                        <td>
                            <FlexBox style={{gap: "12px"}} justify="start" align="center">
                                {privileges.includes(TEST_REVIEW_PRIVILEGE)
                                    ?<>
                                        <TestReviewButton quiz={q} navigate={navigate}/>
                                    </>
                                    :
                                    ""}

                                {(q.quizScore || q.quizScore === 0) && q.quizScore !== -1 && !isLiveTestOrQuiz(q) &&
                                    <img src={testReportIcon} title="Performance Report" style={{cursor:"pointer", width:"24px", height:"24px"}}
                                        onClick={() => navigate(
                                            `/TestReport?score=${Math.floor(q.quizScore)}&testKey=${encodeURIComponent(q.key)}&externalQuizId=${encodeURIComponent(q.key)}&companyKey=${encodeURIComponent(company.key || '')}&quizName=${encodeURIComponent(q.testName || q.name || '')}&candName=${encodeURIComponent(q.candidateName || '')}&resultsRaw=${encodeURIComponent(q.results || '')}&candidateTime=${encodeURIComponent(q.timeTaken || 0)}&totalTime=${encodeURIComponent(q.quizTime || 0)}&totalQuestions=${encodeURIComponent(q.amountOfQuestions || 0)}&testDate=${encodeURIComponent(new Date(q.date).toISOString().split('T')[0])}`
                                        )}
                                    />
                                }

                                {q.quizScore === -1 && !isLiveTestOrQuiz(q)
                                ? <RestoreButton quiz={q} company={company} setQuizzes={setQuizzes} />
                                : <TestChartsButton quiz={q} navigate={navigate} />
                                }
                          
                                <ResendResultsIcon hidden={(!q.quizScore && q.quizScore !== 0) || q.quizScore == -1} onClick={() => {
                                    resendResults(q.key, candidate.key)
                                }} title='Resend Results' cursor="pointer"/>
                            </FlexBox>
                        </td>
                    </TableRow>)
                }

            })}
        </TableBody>
        {showConfirmDelete
            && <ConfirmModal variant={"danger"} show={showConfirmDelete} setShow={setShowConfirmDelete}
                             callback={deleteQuiz} body={"Are you sure you want to delete " + getCandidateFullName(candidate)+ "'s "+selectedQuiz.name+" quiz?"}
                             title={"Confirm Delete"} yes={"Delete"} no={"Cancel"}
                             fallback={e => setShowConfirmDelete(false)}/>}
    </Table></div>;
}



// Mobile Notes Card Component
const MobileNotesCard = ({candidate}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [notes, setNotes] = useState("");

    useEffect(() => {
        if (candidate) setNotes(candidate.notes || "");
    }, [candidate]);

    const hasContent = notes && notes.trim().length > 0;

    return (
        <div className={`mobile-notes-card ${isOpen ? 'open' : 'closed'} ${hasContent && !isOpen ? 'has-preview' : ''}`}>
            <div className="mobile-notes-header" onClick={() => setIsOpen(!isOpen)}>
                <img src={notesIcon} alt="Notes" className="mobile-notes-icon" />
                <div className="mobile-notes-text-container">
                    <span className="mobile-notes-title">Notes</span>
                    {!isOpen && hasContent && (
                        <span className="mobile-notes-preview">{notes}</span>
                    )}
                </div>
                <img
                    src={downArrowNotes}
                    alt="Toggle"
                    className={`mobile-notes-arrow ${isOpen ? 'rotated' : ''}`}
                />
            </div>
            {isOpen && (
                <div className="mobile-notes-content">
                    {notes || "No notes available"}
                </div>
            )}
        </div>
    );
};

export default Candidate



